import React from 'react';
import { Button, Modal, Toast } from '@kaleyra/emmy';
import { useTranslation } from 'react-i18next';
import Styles from './index.module.scss';
import { useHistory } from 'react-router-dom';
import * as urls from '../../../../../../urls';

export type BaseSeeMorePropsType = {
    visible: boolean;
};

export type DispatchPropsType = {
    onClose: () => void;
}

const CancelConfigurationFormModal: React.FC<BaseSeeMorePropsType & DispatchPropsType> = ({ onClose, visible }) => {
    const { t } = useTranslation();
    const history = useHistory();

    const handleCancelForm = () => {
        onClose();
        history.push(urls.v1SMS({ tab: 'receive-message' }))
    }

    const renderFooterBody = () => {
        return (
            <>
                <Button type="tertiary" onClick={() => { onClose() }}>{t('no')}</Button>
                <Button className={Styles.deleteBtn} type="danger" onClick={() => handleCancelForm()}>{t('cnf')}</Button>
            </>
        )
    }

    return (
        <Modal
            visible={visible}
            title={t('KLR01803')}
            body={t('KLR03052')}
            footer={renderFooterBody()}
        />
    );
}

export default CancelConfigurationFormModal;